import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CalendarEvent, CalendarEventAction } from 'angular-calendar';
import { Subscription } from 'rxjs';
import { ApiError, AuthService, MessageService } from '../../../core';
import { isOrigemRetorno } from '../atividade-origem';
import { AtividadeSearchAtividade } from '../atividade-search';
import { AtividadeSearchOrderBy } from '../atividade-search-orderby';
import { AtividadeUpdateConcluida } from '../concluida';
import { AtividadeFilter } from '../filter';
import { AtividadeConcluidaHttpService, AtividadeSearchHttpService } from '../services';

@Component({
    selector: 'sgt-atividade-calendar',
    templateUrl: 'atividade-calendar.component.html',
    styleUrls: ['./atividade-calendar.component.less'],
})
export class AtividadeCalendarComponent implements OnInit {
    idUsuarioLogado: number;
    private searchSubs$: Subscription;

    @Input() filter: AtividadeFilter;
    @Output() edit = new EventEmitter<AtividadeSearchAtividade>();
    @Output() delete = new EventEmitter<AtividadeSearchAtividade>();

    /** Ações dos eventos das atividades no calendar */
    private actions: CalendarEventAction[] = [
        {
            label: '<i class="far fa-trash-alt" aria-hidden="true"></i>',
            a11yLabel: 'Excluir',
            cssClass: 'dropdown-item-delete',
            onClick: ({ event }: { event: CalendarEvent<AtividadeSearchAtividade> }): void => {
                if (!event || !event.meta) {
                return;
            }
            this.delete.emit(event.meta);
        },
        },
    ];

    events: CalendarEvent<AtividadeSearchAtividade>[] = [];

    constructor(private authService: AuthService,
                private messageService: MessageService,
                private atividadeSearchHttpService: AtividadeSearchHttpService,
                private atividadeConcluidaHttpService: AtividadeConcluidaHttpService) {}

    ngOnInit(): void {
        this.idUsuarioLogado = this.authService.getIdUsuario();
    }

    /** Verifica se a origem da atividade é retorno */
    isOrigemRetorno(atividade: AtividadeSearchAtividade): boolean {
        return isOrigemRetorno(atividade?.origem);
    }

    /** Ao clicar em algum evento de atividade */
    eventClicked(event: CalendarEvent<AtividadeSearchAtividade>) {
        if (!event) {
            return;
        }
        this.edit.emit(event.meta);
    }

    eventUpdated(event: CalendarEvent<AtividadeSearchAtividade>) {
        // TODO: ATUALIZAR DATA DE PRAZO DA ATIVIDADE
    }

    onDatesChange() {
        this.search();
    }

    /** Realiza a pesquisa das atividades */
    search() {
        // Realizando unsubscribe dos subscriptions atuais e criando um novo para as próximas pesquisas
        this.searchSubs$?.unsubscribe();
        this.searchSubs$ = new Subscription();
        this.events = [];
        this.searchSubs$.add(
            this.atividadeSearchHttpService.atividades(this.filter, -1, -1, AtividadeSearchOrderBy.DiaPrazoESequencia, 'asc')
                .subscribe((atividades) => {
                    this.events = atividades?.map<CalendarEvent<AtividadeSearchAtividade>>((atividade) => {
                        const event: CalendarEvent<AtividadeSearchAtividade> = {
                            id: atividade.id,
                            start: new Date(atividade.diaPrazo),
                            end: new Date(atividade.diaPrazo),
                            title: atividade.titulo,
                            meta: atividade,
                            draggable: false,
                            resizable: {
                                afterEnd: false,
                                beforeStart: false,
                            },
                            actions: this.actions,
                        };
                        this.setEventColors(event);

                        return event;
                    });
                },
                (error: ApiError) => this.messageService.error(error.message, 'Erro ao pesquisar as atividades', error)
            )
        );
    }

    /** Seta a cor do evento da atividade conforme a situação atual da atividade */
    private setEventColors(event: CalendarEvent<AtividadeSearchAtividade>) {
        if (!event || !event.meta) {
            return;
        }
        if (event.meta.atrasada) {
            event.color = {
                primary: '#f55e59',
                secondary: '#ffe3e3',
            };
        } else if (event.meta.concluida) {
            event.color = {
                primary: '#20b75d',
                secondary: '#e3f3e9',
            };
        } else if (event.meta.pendente) {
            event.color = {
                primary: '#6d6a6a',
                secondary: '#e9ebed',
            };
        }
    }

    /** Realiza a atualização na atividade marcando a mesma como concluída ou não */
    updateConcluida(event: CalendarEvent<AtividadeSearchAtividade>, atividade: AtividadeSearchAtividade) {
        if (!atividade || !atividade.id) {
            return;
        }

        const entityUpdate = new AtividadeUpdateConcluida(atividade.id, atividade.concluida);
        this.atividadeConcluidaHttpService.updateConcluida(entityUpdate)
            .subscribe((response) => {
                if (response) {
                    atividade.pendente = response.pendente;
                    atividade.concluida = response.concluida;
                    atividade.atrasada = response.atrasada;
                    this.setEventColors(event);
                }
            },
            (error: ApiError) => {
                atividade.concluida = !atividade.concluida;
                this.messageService.error(error.message, 'Ocorreu um erro ao atualizar a conclusão da atividade', error);
            }
        );
    }
}
